export default "__VITE_ASSET__40a910e0__"